export enum RefreshAccessResponseType {
    refreshTokenExpired = 1,
    serverError = 2,
    success = 3
}
